import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgDollar} from "~/assets/svg/dollar.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmDollarIcon: React.FC<IIconBase> = ({id, size = "xs", color = designColors.black, className}) => {
  return <SvgDollar id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
